import { useEffect, useState } from "react";
import "./App.css";

const AK_EPOCH_UTC = Date.parse("2025-09-10T18:23:00Z");

function getAKSeconds() {
  const now = Date.now();
  return Math.floor((now - AK_EPOCH_UTC) / 1000);
}

function App() {
  const [akSeconds, setAkSeconds] = useState(getAKSeconds());

  useEffect(() => {
    const timer = setInterval(() => {
      setAkSeconds(getAKSeconds());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="App" style={{ textAlign: "center", marginTop: "20vh" }}>
      <h1>Hello World</h1>
      <p style={{ fontSize: "1.2rem", opacity: 0.7 }}>
        Current AK Time
      </p>
      <p style={{ fontSize: "2.5rem", fontWeight: "bold" }}>
        {akSeconds} AK
      </p>
    </div>
  );
}

export default App;
